import { render, staticRenderFns } from "./StudentWelcomePage.vue?vue&type=template&id=7f4b4d58&scoped=true&"
import script from "./StudentWelcomePage.vue?vue&type=script&lang=ts&"
export * from "./StudentWelcomePage.vue?vue&type=script&lang=ts&"
import style0 from "./StudentWelcomePage.vue?vue&type=style&index=0&id=7f4b4d58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4b4d58",
  null
  
)

export default component.exports